import React, { cloneElement, isValidElement, useRef } from 'react';
import classNames from 'classnames';
import { isForwardRefChild, useTranslation } from '@weareconceptstudio/core';
import ErrorMessage from '../../error-message';
import { useInput } from '../hooks/useInput';
import { useRules } from '../hooks/rules';
const FormItem = ({ label, name, children, className, errorKey, required = true, requiredMessage, rules = [], noStyle = false, }) => {
    if (!isValidElement(children)) {
        return null;
    }
    const childRef = useRef(null);
    const { translate } = useTranslation();
    const { fieldState } = useInput({
        name,
        rules: useRules({
            rules,
            required,
            requiredMessage,
            errorKey: errorKey || label,
            // @ts-ignore
            childType: childRef?.current?.childType || '',
        }),
        errorKey: errorKey || label,
    });
    const { error, invalid } = fieldState;
    const classString = classNames('form-item', {
        [className]: className,
        'has-error': error || invalid,
        // @ts-ignore
        disabled: children.props.disabled,
    });
    // @ts-ignore
    const inlineProps = isForwardRefChild(children) ? { ref: childRef, name } : { name };
    if (noStyle) {
        return (React.createElement(React.Fragment, null,
            cloneElement(children, inlineProps),
            React.createElement(ErrorMessage, { name: name, as: React.createElement("div", { className: 'error-message' }) })));
    }
    return (React.createElement("div", { className: classString },
        React.createElement("div", { className: 'form-item-row' },
            label ? (React.createElement("div", { className: 'form-item-label' },
                React.createElement("label", { htmlFor: name, "data-required": required },
                    translate(label),
                    required ? React.createElement("span", { className: 'required-symbol' }, "*") : null))) : null,
            React.createElement("div", { className: 'form-item-control' }, cloneElement(children, inlineProps)),
            React.createElement(ErrorMessage, { name: name, as: React.createElement("div", { className: 'error-message' }) }))));
};
export default FormItem;
//# sourceMappingURL=index.js.map